<template>
  <div>
    <div>
      <tdesk-notice
        v-if="userCanInvoice"
        importance="primary"
        type="warning"
        icon="fas fa-exclamation-triangle"
        message="Invoicing only available for group enrolment flow"
      />
    </div>
    <div class="booking-card-outer-container">
      <div id="individual-booking" class="tdesk-container" @click="selectSignUpFlow('self')">
        <div class="booking-card-inner-container">
          <i class="fas fa-user" />
          <p>Enrol Myself</p>
          <i class="fas fa-chevron-circle-right" />
        </div>
      </div>
      <div
        v-if="!passAndPay"
        id="group-booking"
        class="tdesk-container"
        @click="selectSignUpFlow('multi-user')"
      >
        <div class="booking-card-inner-container">
          <i class="fas fa-users" />
          <p>Enrol Others or a Group</p>
          <i class="fas fa-chevron-circle-right" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TdeskNotice from '../../../components/tdesk_notice.vue';

export default {
  components: {TdeskNotice},
  props: {
    passAndPay: { type: Boolean, required: true },
    userCanInvoice: { type: Boolean, required: true },
  },
  methods: {
    selectSignUpFlow(flowType) {
      this.$emit('update-sign-up-flow', flowType);
    },
  },
};
</script>
